import { render, staticRenderFns } from "./PedidosCerradosTable.vue?vue&type=template&id=f1996dd6"
import script from "./PedidosCerradosTable.vue?vue&type=script&lang=js"
export * from "./PedidosCerradosTable.vue?vue&type=script&lang=js"
import style0 from "./PedidosCerradosTable.vue?vue&type=style&index=0&id=f1996dd6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports